<template>
    <div id="app">
        <router-view />
        <!-- 图文验证弹框 -->
        <van-overlay :show="verifyLogin">
            <div class="captcha_box">
                <span class="captcha_title">请输入图形验证码</span>
                <div class="captcha_img_box">
                    <img src="./assets/image/icon_cancel.png" alt="" class="close_icon" @click='onClosePopup'>
                    <div class="captcha_inp">
                        <van-field v-model="captchaCode" :formatter="formatter" placeholder="请输入" />
                    </div>
                    <img :src="verifyImg" class="captcha_img" @click="replaceImg('replaceImg')" />
                </div>
                <div class="btn">
                    <van-button block round color='#f57341' type="primary" @click="checkCaptchaCode">确定</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { checkCaptchaCode } from '@/api/public'
import { Notify } from 'vant';
export default {
    name: "App",
    data() {
        return {
            captchaCode: '',
        }
    },
    computed: {
        verifyLogin: {
            get() {
                return this.$store.getters.verifyLogin != '' ? true : false
            },
            set() {

            }
        },
        verifyImg() {
            return this.$store.getters.verifyImg || ''
        },
    },
    created() {
        //重写alert方法，去掉地址显示
        window.alert = function (name) {
            var iframe = document.createElement("IFRAME");
            iframe.style.display = "none";
            iframe.setAttribute("src", "data:text/plain,");
            document.documentElement.appendChild(iframe);
            window.frames[0].window.alert(name);
            iframe.parentNode.removeChild(iframe);
        };
    },
    mounted() {
    },
    methods: {
        // 关闭弹框
        onClosePopup() {
            this.$store.commit('app/SET_VERIFY_LOGIN', '') //清除图文验证

        },
        formatter(value) {
            // 过滤输入的数字
            return value.replace(/[^A-Za-z0-9]/g, '');
        },
        checkCaptchaCode() {
            if (this.captchaCode.length == 0) {
                Notify({ type: 'warning', message: '请输入验证码' });
                return
            }
            checkCaptchaCode({ key: this.$store.getters.verifyLogin, captchaCode: this.captchaCode }).then(res => {
                this.captchaCode = ''
                if (res.code != '00000000') {
                    Notify({ type: 'danger', message: res.msg });
                    this.$store.dispatch('app/getVerifyImg')
                    return
                }
                Notify({ type: 'success', message: '验证成功' });

                this.$store.commit('app/SET_VERIFY_LOGIN', '')
                this.$store.commit('app/SET_VERIFY_IMG', '')
            })
        },
        replaceImg() {
            this.$store.dispatch('app/getVerifyImg', this.$store.getters.verifyLogin)
        }
    }
};
</script>

<style lang='less'>
* {
    padding: 0;
    margin: 0;
    // font-size: 28px;
}
html,
body {
    background-color: #f9f9f9;
    color: #333;
}
div {
    box-sizing: border-box;
}
img {
    // display: block;
}
.noList {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    justify-content: center;
    padding-bottom: 100px;
    position: fixed;
    width: 750px;
    z-index: 888;
    background-color: #fff;
}
.noList img {
    width: 236px;
    height: 238px;
    margin-bottom: 46px;
}
.noList span {
    color: #bbbbbb;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 200px;
}
.page {
    max-width: 750px;
    margin: 0 auto;
}
.yqhy {
    width: 147px;
    height: 47px;
    position: fixed;
    top: 210px;
    right: 0px;
    z-index: 3;
}
._fullscreen {
    display: none !important;
}
.qun-base-controls,
._play-btn {
    z-index: 200 !important;
}
.van-image-preview__index {
    top: 60px !important;
}
.van-uploader__upload {
    border: 2px dashed #999;
    border-radius: 8px;
}

.captcha_box {
    width: 606px;
    padding: 48px 0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-color: #fff;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close_icon {
        width: 36px;
        position: absolute;
        top: 48px;
        right: 48px;
    }

    .captcha_title {
        font-size: 36px;
        line-height: 50px;
        font-weight: 700;
    }

    .captcha_img_box {
        display: flex;
        align-items: center;
        width: 510px;
        height: 100px;
        border-radius: 6px;
        border: 2px solid #dfdfdf;
        margin: 36px 0;
        overflow: hidden;

        .captcha_inp {
            height: 96px;
            width: 314px;
            font-size: 32px;
            line-height: 96px;
            display: flex;
            align-items: center;
        }

        .captcha_img {
            width: 192px;
            height: 96px;
        }
    }

    .btn {
        width: 510px;
    }
}
.state_box {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;

    .state_box_img {
        width: 236px;
    }
    .state_box_img2 {
        width: 360px;
    }
    .state_box_text {
        margin-top: 48px;
        color: #bbb;
        font-size: 24px;
        line-height: 34px;
        max-width: 520px;
        text-align: center;
    }
    .state_box_text2 {
        margin-top: 16px;
        color: #999;
        font-size: 28px;
        line-height: 34px;
    }
    .state_box_btn {
        padding: 10px 50px;
        border-radius: 10px;
        border: 2px solid #f57341;
        font-size: 28px;
        line-height: 40px;
        color: #f57341;
        background-color: transparent;
        margin-top: 48px;
    }

    .state_box_btn2 {
        margin-top: 60px;
        padding: 0 65px;
        height: 80px;
        background: linear-gradient(90deg, #f0643c 0%, #ff965a 100%);
        text-align: center;
        line-height: 80px;
        font-weight: 700;
        font-size: 32px;
        color: #fff;
        border-radius: 40px;
    }
}
</style>
